import React from 'react';

/**
 * retaining the class name as there might few styles to be applied from the carousel lib.
 * that might create other issues
 */
const CarouselDots = () => {
  return <div className="slick-dots__item"></div>;
};

export function getCustomPaging(): JSX.Element {
  return <CarouselDots />;
}

export default CarouselDots;
